import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import ThemeToggleFloating from "@/components/ThemeToggleFloating";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.toLowerCase().trim(), origin: window.location.origin });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background grid-bg relative">
      <ThemeToggleFloating className="top-4 right-4" />
      <form onSubmit={submit} className="w-full max-w-md bg-card border-2 border-foreground p-8 heavy-shadow">
        <div className="flex justify-center mb-6">
          <div className="bg-[#0b1735] p-3 border-2 border-foreground/20">
            <img
              src="/logo-meerjarenplan.png"
              alt="MeerjarenplanOnline.nl"
              className="h-8 w-auto"
              data-testid="brand-logo"
            />
          </div>
        </div>
        <div className="stat-label mb-2">{t("Toegang · Herstel")}</div>
        <h1 className="font-display font-black text-4xl uppercase tracking-tighter mb-4">{t("Wachtwoord vergeten?")}</h1>

        {sent ? (
          <div data-testid="forgot-sent" className="border-2 border-positive/50 bg-positive/10 text-foreground p-4">
            <p className="font-bold mb-2">{t("Check je inbox.")}</p>
            <p className="text-sm text-muted-foreground">
              {t("Als er een account bij dit e-mailadres hoort, hebben we je een reset-link gestuurd. De link is 1 uur geldig.")}
            </p>
            <Link to="/login" data-testid="link-login" className="mt-4 inline-flex items-center gap-1 text-primary font-bold underline underline-offset-2">
              <ArrowLeft className="w-4 h-4" /> {t("Terug naar inloggen")}
            </Link>
          </div>
        ) : (
          <>
            <p className="text-sm text-muted-foreground mb-4">
              {t("Vul je e-mailadres in. Als het bij ons bekend is, krijg je een reset-link toegestuurd.")}
            </p>
            <label className="stat-label">Email</label>
            <input
              type="email" required autoFocus value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email"
              className="w-full mt-1 mb-4 border-2 border-foreground bg-background px-3 py-2 font-mono-num focus:outline-none focus:ring-2 focus:ring-primary"
            />
            <button disabled={busy || !email} data-testid="forgot-submit"
              className="btn-brutal w-full bg-primary text-primary-foreground py-3 font-display uppercase font-black tracking-wider text-lg disabled:opacity-70">
              {busy ? t("Bezig…") : t("Verstuur reset-link")}
            </button>
            <p className="mt-4 text-sm text-muted-foreground">
              <Link to="/login" data-testid="link-login" className="inline-flex items-center gap-1 text-primary font-bold underline underline-offset-2">
                <ArrowLeft className="w-4 h-4" /> {t("Terug naar inloggen")}
              </Link>
            </p>
          </>
        )}
      </form>
    </div>
  );
}
